import { Item } from './Item/Item'
import style from './MarkdownTemplates.module.scss'

interface IProps {
    onAddMarkdownTemplate: (template: string) => void
}

export const MarkdownTemplates = (props: IProps) => {
    const { onAddMarkdownTemplate } = props
    const markdownVariants = [
        {
            title: 'Таблицы',
            descriptions: 'Создайте разметку в соответствии с требованиями таблицы по шаблону',
            template:
                'заголовок 1 | заголовок 2 | заголовок 3\n-|-|-\nстрока 1.1 | строка 1.2 | строка 1.3\nстрока 2.1 | строка 2.2 | строка 2.3\nстрока 3.1 | строка 3.2 | строка 3.3\nстрока 4.1 | строка 4.2 | строка 4.3'
        },
        {
            title: 'Заголовок XL',
            descriptions: 'Огромный заголовок',
            template: '# Текст'
        },
        {
            title: 'Заголовок L',
            descriptions: 'Большой заголовок',
            template: '## Текст'
        },
        {
            title: 'Заголовок M',
            descriptions: 'Средний заголовок',
            template: '### Текст'
        },
        {
            title: 'Заголовок S',
            descriptions: 'Маленький заголовок',
            template: '#### Текст'
        },
        {
            title: 'Ссылка',
            descriptions: 'Гипер ссылка с наименованием',
            template: '[Наименование ссылки](URL ссылки)'
        },
        // {
        //     title: 'Картинка',
        //     descriptions: 'Картинка передающаяся по ссылке',
        //     template: '![Наименование картинки](URL картинки)'
        // },
        {
            title: 'Выделение',
            descriptions: 'Дополнительный информативный блок, бросающийся в глаза',
            template: '[(...Введите текст...)]'
        }
    ]
    return (
        <div className={style.container}>
            {markdownVariants.map((item, idx) => (
                <Item key={idx} onAddMarkdownTemplate={onAddMarkdownTemplate} {...item} />
            ))}
        </div>
    )
}
